var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('img',{staticStyle:{"width":"175px","height":"auto"},attrs:{"src":_vm.iconUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }